module.exports = {
  home: 'Home',
  about: 'Über',
  aboutUs: 'Über uns',
  portfolio: 'Portfolio',
  team: 'Team',
  news: 'Neuigkeiten',
  contact: 'Kontakt',
  csr: 'CSR',
  esg: 'ESG',
  jobs: 'Jobs',
  investorLogIn: 'Investor Login',
  linkedinConnect: 'Folgen Sie uns auf LinkedIn',
  ourApproach: 'Unser Ansatz',
  careers: 'Karriere',
  corpResponsibility: 'Timbo Africa Stiftung',
  returns: 'Wertsteigerung',
  investmentFocus: 'Investitionsfokus',
  activeApproach: 'Der Aktive Ansatz',
  menu: 'Menü',
  openPositions: 'Stellenangebote',
  allRightsReserved: 'Alle Rechte vorbehalten',
  madeBy: 'programmiert von',
  by: 'von',
  howWeWork: 'Unser Ansatz',
  theACCway: 'Der ACC Weg',
};
